$(() => {
    //ユーザ画面のみで有効
    if (!$('#user-management').length) {
        return;
    }

    $('.delebet-user-but').on('click', function() {
        return confirm('このユーザを削除してもよろしいですか？');
    });

    if (1 == $('#role_id').val()) {
        $('.select2').attr('disabled', true);
    }

    $('#role_id').on('change', function() {
        if (2 == $(this).val()) {
            $('.select2').attr('disabled', false);
        } else {
            $('.select2').attr('disabled', true);
            $('.select2').val('');
        }
    });

    $('.select2').select2({
        ajax: {
            url: '/manager/corporate/get_list',
            dataType: 'json',
            delay: 250
        },
        language: "ja",
        escapeMarkup: function (markup) {
            return markup;
        }
    });
});
